import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-parent" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "General information", -1)
const _hoisted_3 = { class: "grey-form-card" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Address", -1)
const _hoisted_7 = { class: "grey-form-card" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Website", -1)
const _hoisted_9 = { class: "grey-form-card" }
const _hoisted_10 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_DropdownFilter = _resolveComponent("DropdownFilter")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_form = _resolveComponent("el-form")
  const _component_LeavePreventPopup = _resolveComponent("LeavePreventPopup")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      "label-position": "top",
      "label-width": "100px",
      model: _ctx.form,
      rules: _ctx.rules,
      ref: "siteForm"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_form_item, {
            label: "Site name",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                maxlength: 100,
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trim('name')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Country",
            prop: "country_code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown, {
                class: "input-dropdown",
                trigger: "click",
                "hide-on-click": true
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_DropdownFilter, {
                        class: "form-dropdown-filter",
                        filterData: _ctx.state.countries
                      }, null, 8, ["filterData"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    disabled: !_ctx.canEditCountry
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.currentCountry || "-") + " ", 1),
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Data Storage",
            prop: "data_storage"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown, {
                class: "input-dropdown",
                trigger: "click",
                "hide-on-click": true
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_DropdownFilter, {
                        class: "form-dropdown-filter",
                        filterData: _ctx.state.dataStorages
                      }, null, 8, ["filterData"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    disabled: !_ctx.state.dataStorages.items.length || !_ctx.canEditCountry
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.currentDataStorage || "-") + " ", 1),
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Comment",
            prop: "comment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                modelValue: _ctx.form.comment,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.comment = $event)),
                maxlength: 500,
                autosize: { minRows: 4, maxRows: 6 },
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trim('comment')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_el_form_item, {
            label: "Address Line 1",
            prop: "address_line1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.address_line1,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.address_line1 = $event)),
                maxlength: 30,
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trim('address_line1')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Address Line 2",
            prop: "address_line2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.address_line2,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.address_line2 = $event)),
                maxlength: 30,
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.trim('address_line2')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "City",
            prop: "city"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.city,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.city = $event)),
                maxlength: 100,
                onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.trim('city')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Region",
            prop: "region"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.region,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.region = $event)),
                maxlength: 100,
                onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.trim('region')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Zip/Postcode",
            prop: "zip"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.zip,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.zip = $event)),
                maxlength: 8,
                onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.trim('zip')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_el_form_item, {
            label: "Site address (URL)",
            prop: "web_site"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.web_site,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.web_site = $event)),
                maxlength: 50,
                onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.blurWebsite()))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode("div", _hoisted_10, [
      _createVNode("button", {
        class: "button secondary",
        onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.cancel()), ["prevent"]))
      }, " Cancel "),
      _withDirectives(_createVNode("button", {
        class: "button",
        disabled: !_ctx.isRequiredFilled,
        onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"]))
      }, " Save ", 8, ["disabled"]), [
        [
          _directive_loading,
          _ctx.state.loading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    ]),
    _createVNode(_component_LeavePreventPopup, {
      form: _ctx.form,
      disabled: _ctx.state.isSubmitted
    }, null, 8, ["form", "disabled"])
  ]))
}